module.exports = __webpack_public_path__ + "static/img/taiHeImg4.65d0b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg4.png
// module id = jGpm
// module chunks = 2